/* DisableDefinitionMenu.tsx generated by @compiled/babel-plugin v0.38.1 */
import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
var _excluded = ["triggerRef"];
import "./DisableDefinitionMenu.compiled.css";
import * as React from 'react';
import { ax, ix } from "@compiled/react/runtime";
import { useEffect, useState } from 'react';
import { defineMessages, useIntl } from 'react-intl-next';
import { IconButton } from '@atlaskit/button/new';
import DropdownMenu from '@atlaskit/dropdown-menu';
import MoreIcon from '@atlaskit/icon/core/migration/show-more-horizontal--more';
import { N200, N700, N800 } from '@atlaskit/theme/colors';
import Toggle from '@atlaskit/toggle';
import Tooltip from '@atlaskit/tooltip';
import { useAIAnswerContext } from '../../../../ai-answer-dialog/ai-answer-context';
var messages = defineMessages({
  disable_definitions_more_icon_tooltip: {
    id: 'search_ai.disable_definitions_more_icon_tooltip',
    defaultMessage: 'See more actions',
    description: 'Tooltip for definition more icon'
  },
  disable_definitions_header: {
    id: 'search_ai.disable_definitions_header',
    defaultMessage: 'Don’t recommend definitions at all',
    description: 'Header text for definitions menu option to disable autohighlighting for all pages'
  },
  disable_definitions_description: {
    id: 'search_ai.disable_definitions_description',
    defaultMessage: 'When this is on, we’ll no longer automatically highlight terms and acronyms on any page. Only you will see these changes.',
    description: 'Description text for the reading aids menu option to not disable auto highlighting for all pages'
  }
});
var DisableDefinitionMenuWrapper = null;
var DisableDefinitionMenuTextWrapper = null;
var DisableDefinitionMenuHeaderStyles = null;
var DisableDefinitionMenuDescriptionStyles = null;
var DisableDefinitionMenuToggleWrapper = null;
var MoreIconStyled = function MoreIconStyled() {
  return /*#__PURE__*/React.createElement(MoreIcon, {
    label: "reading-aids-menu-button-icon",
    color: "var(--ds-icon-subtle, ".concat(N700, ")")
  });
};
export var DisableDefinitionsMenu = function DisableDefinitionsMenu() {
  var _useAIAnswerContext = useAIAnswerContext(),
    readingAidsOptions = _useAIAnswerContext.readingAidsOptions;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    menuOpen = _useState2[0],
    setMenuOpen = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    disableDefinitions = _useState4[0],
    setDisableDefinitions = _useState4[1];
  useEffect(function () {
    var _readingAidsOptions$d;
    var definitionsDisabled = !!(readingAidsOptions !== null && readingAidsOptions !== void 0 && (_readingAidsOptions$d = readingAidsOptions.disableDefinitionsCallbacks) !== null && _readingAidsOptions$d !== void 0 && _readingAidsOptions$d.getDefinitionsDisabled());
    setDisableDefinitions(definitionsDisabled);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  var _useIntl = useIntl(),
    formatMessage = _useIntl.formatMessage;
  var disableDefinitionsCallbacks = readingAidsOptions === null || readingAidsOptions === void 0 ? void 0 : readingAidsOptions.disableDefinitionsCallbacks;
  return disableDefinitionsCallbacks ? /*#__PURE__*/React.createElement(Tooltip, {
    position: "bottom",
    content: formatMessage(messages.disable_definitions_more_icon_tooltip)
  }, /*#__PURE__*/React.createElement(DropdownMenu, {
    isOpen: menuOpen,
    trigger: function trigger(_ref) {
      var triggerRef = _ref.triggerRef,
        props = _objectWithoutProperties(_ref, _excluded);
      return /*#__PURE__*/React.createElement(IconButton, _extends({}, props, {
        appearance: "subtle",
        icon: MoreIconStyled,
        ref: triggerRef,
        onClick: function onClick() {
          setMenuOpen(!menuOpen);
        },
        testId: "definitions-menu-button",
        label: "definitions-menu-button"
      }));
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: ax(["_zulpv47k _1e0c1txw _1bsbnklw _2lx2vrvc _1bah1yb4 _1pbykb7n _19pkpxbi _n3tdpxbi _19bvutpp _2hwx12x7"])
  }, /*#__PURE__*/React.createElement("div", {
    className: ax(["_zulp1b66 _1e0c1txw _2lx21bp4 _1bsbohmy"])
  }, /*#__PURE__*/React.createElement("div", {
    className: ax(["_11c82smr _syaz1o8f"]),
    style: {
      "--_ggxzyp": ix("var(--ds-text, ".concat(N800, ")"))
    }
  }, formatMessage(messages.disable_definitions_header)), /*#__PURE__*/React.createElement("div", {
    className: ax(["_11c81o8v _syazpsu8"]),
    style: {
      "--_vrm7dk": ix("var(--ds-text-subtlest, ".concat(N200, ")"))
    }
  }, formatMessage(messages.disable_definitions_description))), /*#__PURE__*/React.createElement("div", {
    className: ax(["_1e0c1txw _1bsb1ns9"])
  }, /*#__PURE__*/React.createElement(Toggle, {
    onChange: function onChange() {
      if (disableDefinitions) {
        disableDefinitionsCallbacks.onEnableDefinitions();
      } else {
        disableDefinitionsCallbacks.onDisableDefinitions();
      }
      setDisableDefinitions(!disableDefinitions);
    },
    isChecked: disableDefinitions,
    testId: "definitions-toggle-disable"
  }))))) : null;
};